'use client';

import { Box, css, VStack } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';
import { MetaDefault } from '../../../../components/typography';

const screenshotFrameStyle = css({
  display: 'block',
  width: '100%',
  maxHeight: '360px',
  objectFit: 'contain',
  borderRadius: 'md',
  borderWidth: '1px',
  borderColor: 'border',
  bg: 'bg.muted',
});

type BrowserSnapshotScreenshotProps = {
  url: string;
  showLabel?: boolean;
};

export function BrowserSnapshotScreenshot({
  url,
  showLabel = true,
}: BrowserSnapshotScreenshotProps) {
  const t = useTranslations('designSystem.chat.browserResult');

  return (
    <VStack alignItems="flex-start" gap={1} width="100%" mt={showLabel ? 3 : 0}>
      {showLabel ? (
        <MetaDefault color="fg.muted">{t('screenshot')}</MetaDefault>
      ) : null}
      <Box width="100%">
        <img className={screenshotFrameStyle} src={url} alt={t('screenshot')} />
      </Box>
    </VStack>
  );
}
